import { Component, createElement, cloneElement } from "react";
import { Route, Switch } from "react-router-dom";

class HeaderContainer extends Component {
    render() {
        return (
            <Switch>
                {this.props.publicRoutes.map((route, index) => (
                    <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        component={route.header}
                        title={route.title}
                    />
                ))}
                {this.props.privateRoutes.map((route, index) => (
                    <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        render={(props) => {
                            let element = createElement(route.header);

                            return cloneElement(element, { ...props, globalStore: this.props });
                        }}
                        title={route.title}
                    />
                ))}
            </Switch>
        );
    }
}

export default HeaderContainer;
